// extracted by mini-css-extract-plugin
export default {"melodyCardCategory":"Q5-z","categoryName":"R5-z","categoryImage":"S5-z","categoryContent":"T5-z","bottomAligned":"U5-z"};